/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Createdeal2Inputs */

const en_coinvestments_error_createdeal2 = /** @type {(inputs: Coinvestments_Error_Createdeal2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create deal`)
};

/**
* | output |
* | --- |
* | "Failed to create deal" |
*
* @param {Coinvestments_Error_Createdeal2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_createdeal2 = /** @type {((inputs?: Coinvestments_Error_Createdeal2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Createdeal2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_createdeal2(inputs)
});
export { coinvestments_error_createdeal2 as "coInvestments_error_createDeal" }